import { render, staticRenderFns } from "./HeaderNavAFA.vue?vue&type=template&id=61572b5a&scoped=true&"
import script from "./HeaderNavAFA.vue?vue&type=script&lang=js&"
export * from "./HeaderNavAFA.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNavAFA.vue?vue&type=style&index=0&id=61572b5a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61572b5a",
  null
  
)

export default component.exports